var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M52.5 17.5a7.001 7.001 0 11-14.002-.001A7.001 7.001 0 0152.5 17.5h0zm-4.32-2.68l-5.36 5.36m0-5.36l5.36 5.36m-3.159 4.352v15.89a1.705 1.705 0 01-1.702 1.703H6.727a1.706 1.706 0 01-1.703-1.703v-21.78a1.706 1.706 0 011.703-1.703h31.7m-11.622 5.465H40.11M35.913 36.58h4.197v-4.198h-4.197v4.198h0zm-20.896-2.05h2.623m2.627 0h2.624m2.627 0h2.623m-18.375 0h2.624"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAccount);
export default __webpack_public_path__ + "static/media/close-account.e1acd5d9.svg";
export { ForwardRef as ReactComponent };